<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="300px"
    :close-on-click-overlay="true"
    :before-close="closeBefore"
  >
    <div class="customer-container">
      <div class="customer-info">
        <div class="customer-info-title">
          <img src="@/assets/images/ic_dialog_b_1.png" alt="" />
          <h1>客服中心</h1>
          <img src="@/assets/images/ic_dialog_b_2.png" alt="" />
        </div>

        <div class="customer-platform">
          <div class="platform-item">
            <div class="platform-item-info">
              <img src="@/assets/images/ic_wechat.png" alt="" />
              <span>微信：<span id="wx">{{WMServiceConfig.wechat}}</span></span>
            </div>

            <span class="copy" @click="textToCopy(WMServiceConfig.wechat)">复制</span>
          </div>
          <div class="platform-item">
            <div class="platform-item-info">
              <img src="@/assets/images/ic_qq.png" alt="" />
              <span>qq：<span id="qq">{{WMServiceConfig.QQ}}</span></span>
            </div>

            <span class="copy" @click="textToCopy(WMServiceConfig.QQ)">复制</span>
          </div>
          <div class="platform-item">
            <div class="platform-item-info">
              <img src="@/assets/images/ic_wx_public.png" alt="" />
              <span
                >微信公众号：<br />
                <span id="gzh">{{WMServiceConfig.account}}</span></span
              >
            </div>
            <span class="copy" @click="textToCopy(WMServiceConfig.account)">复制</span>
          </div>
        </div>
      </div>
      <div class="customer-time">
        <h1>在线时间</h1>
        <span>工作日 ： 8:00 - 22:30</span>
        <span>其&nbsp;&nbsp;&nbsp; 他 ： 9:00 - 22:00</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import copy from 'copy-to-clipboard';
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      WMServiceConfig: {}
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.getCustomerInfo()
  },
  methods: {
    closeBefore(action, done) {
      this.$emit("handleClose", action, done);
    },
    /**
     * 文本复制
     */
    textToCopy(text) {
      copy(text)
      this.$toast("已复制到剪切板！");
    },
    /**
     * 获取客服数据
     */
    async getCustomerInfo() {
      fetch("/static/CustomerServiceConfigData.json")
        .then((response) => response.json())
        .then((data) => {
          console.log(data.WMServiceConfig, 'data')
          this.WMServiceConfig = data.WMServiceConfig
        })
        .catch((error) => {
          this.$toast(error)
        });
    },
  },
};
</script>

<style lang="scss">
.customer-container {
  .customer-info {
    text-align: center;
    .customer-info-title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      margin-top: 50px;

      img {
        width: 90px;
        height: 2px;
      }
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #000000;
        line-height: 40px;
        margin: 0 18px;
      }
    }
    .customer-platform {
      padding: 0 75px;

      .platform-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 25px;
        background: #f6f6f6;
        border-radius: 8px;
        height: 80px;
        margin-bottom: 30px;

        .platform-item-info {
          display: flex;
          align-items: center;

          img {
            width: 60px;
            height: 60px;
            margin-right: 20px;
          }

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            line-height: 33px;
          }
        }

        .copy {
          width: 90px;
          height: 40px;
          background: #ff7a3e;
          border-radius: 30px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #ffffff;
          line-height: 40px;
          margin-left: 26px;
        }
      }
    }
  }
  .customer-time {
    text-align: center;
    width: 100%;
    height: 188px;
    background: #f6f6f6;
    padding: 37px;

    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #000000;
      line-height: 40px;
    }
    span {
      display: block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #000000;
      line-height: 33px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CustomerDialog.vue